import React from 'react'
import { SingleToggleSettingBox } from 'src/Elements/SystemSettings/forms'
import { useField } from 'formik'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { Box, Typography } from '@mui/material'
import WeatherForecastActiveFieldList from 'src/Libs/smart-charge/components/weather-forecast/WeatherForecastActiveFieldList'
import { WeatherForecastStatus } from '../../types'
import { PowermeterHardwareModel } from 'src/Libs/power-meters/models/power-meter.model'

const EMS_WEATHER_REGULATED_CHARGE_ENABLED_FIELD = 'emsWeatherRegulatedChargeEnabled'
const EMS_WEATHER_FORECAST_MODE = 'emsWeatherForecastMode'

interface Props {
  powermeterHardwares: PowermeterHardwareModel[]
  hasWritingRights?: boolean
}

const WeatherForecastFormData: React.FC<Props> = ({ powermeterHardwares, hasWritingRights = true }) => {
  const { t } = useCustomTranslation()
  const [emsWeatherRegulatedChargeEnabledField] = useField(EMS_WEATHER_REGULATED_CHARGE_ENABLED_FIELD)
  const [emsWeatherForecastMode] = useField(EMS_WEATHER_FORECAST_MODE)

  return (
    <Box>
      <SingleToggleSettingBox
        data-qa={'settings-box-weather-forecast'}
        title={t('systemSettings.smartFunctions.smartCharge.weatherForecast.form.weatherForecastLabel')}
        description={t('systemSettings.smartFunctions.smartCharge.weatherForecast.form.weatherForecastDescription')}
        name={EMS_WEATHER_REGULATED_CHARGE_ENABLED_FIELD}
        disabled={!hasWritingRights || emsWeatherForecastMode.value === WeatherForecastStatus.HardLockdown}
      />
      <Typography variant="h2" sx={{ pt: 4, pb: 4 }}>
        {t('systemSettings.smartFunctions.smartCharge.weatherForecast.form.customConfigurationSubtitle')}
      </Typography>
      <WeatherForecastActiveFieldList
        name={'weatherForecastActive'}
        disabled={!emsWeatherRegulatedChargeEnabledField.value || !hasWritingRights}
        powermeterHardwares={powermeterHardwares}
      />
      <SingleToggleSettingBox
        data-qa={'settings-box-weather-calc-mode'}
        title=""
        description={t('systemSettings.smartFunctions.smartCharge.weatherForecast.form.weatherCalcModeDescription')}
        name={'weatherCalcMode'}
        disabled={!emsWeatherRegulatedChargeEnabledField.value || !hasWritingRights}
      />
    </Box>
  )
}

export default WeatherForecastFormData
